import React from 'react'
import { Modal } from 'react-bootstrap'
import { config } from '../Config/config'

export default class AktifkanWallet extends React.Component {
    render() {
        const {setShowAktivasi,cancelAktif,Wallet,cekpin,
        changehandlerpin,cancelpin,setShowPin,pin,errors,
        pinValidation,pinVerification,status} = this.props

        if(status == "Aktifkan"){
        return (
            <div class="mb-10">
                <Modal show={setShowAktivasi}>
                    <Modal.Header>
                        <Modal.Title>Aktifkan Dompet</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <h5>Apakah anda ingin mengaktifkan dompet?</h5>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div>
                            <button type="button" class="btn btn-danger" style = {{margin:"0 5px"}} onClick = {cancelAktif}>Batal</button>
                            <button type="button" class="btn btn-primary"style = {{margin:"0 5px"}} onClick = {cekpin}>Aktifkan</button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={setShowPin} >
                        <Modal.Header>
                            <Modal.Title>Pin Verifikasi</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div class="form-group">
                                <label>Pin</label>
                                <input type="number" class="form-control" style={{ border: "solid blue 1px" }} value={pin} 
                                onChange={changehandlerpin("pin")} />
                                <span className="error"> {errors["pin"]}</span>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-primary" onClick = {pinVerification}>Submit</button>
                            <button type="button" class="btn btn-secondary" onClick={cancelpin} >Cancel</button>
                        </Modal.Footer>
                    </Modal>

            </div>
        )}else if (status == "Tutup"){
            return (
                <div class="mb-10">
                    <Modal show={setShowAktivasi}>
                        <Modal.Header>
                            <Modal.Title>Tutup Dompet</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <h5>Anda saat ini masih memiliki saldo! jika dompet ditutup,saldo anda akan hilang</h5>
                                <h5>Silahkan pindahkan saldo terlebih dahulu ke rekening bank milik anda</h5>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <button type="button" class="btn btn-danger" style = {{margin:"0 5px"}} onClick = {cancelAktif}>Batal</button>
                                <button type="button" class="btn btn-primary"style = {{margin:"0 5px"}} onClick = {cekpin}>Tutup</button>
                            </div>
                        </Modal.Footer>
                    </Modal>
    
                    <Modal show={setShowPin} >
                            <Modal.Header>
                                <Modal.Title>Pin Verifikasi</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div class="form-group">
                                    <label>Pin</label>
                                    <input type="number" class="form-control" style={{ border: "solid blue 1px" }} value={pin} 
                                    onChange={changehandlerpin("pin")} />
                                    <span className="error"> {errors["pin"]}</span>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <button type="button" class="btn btn-primary" onClick = {pinVerification}>Submit</button>
                                <button type="button" class="btn btn-secondary" onClick={cancelpin} >Cancel</button>
                            </Modal.Footer>
                        </Modal>
    
                </div>
            )
        }
    }
}